import React from 'react';

const LiveScenarioMap: React.FC = () => {
  return (
    <div className="bg-gray-200 h-96 rounded-lg flex items-center justify-center">
      <p className="text-gray-500">A live interactive map will be displayed here.</p>
    </div>
  );
};

export default LiveScenarioMap; 